angular.module('hjApp.ui', ['ui.bootstrap']).config([
    '$tooltipProvider',
    function ($tooltipProvider) {
        $tooltipProvider.setTriggers({ showTooltip: 'hideTooltip' });
    }
]);
